export default {
    VERSION: '1.2.8.7',
};

